import React from 'react';

// BD-1496 shown as a near-black chip with gold text
export const OrderChip = ({ value, fallback = 'No order number', testId }) => {
  if (!value) {
    return (
      <span className="text-[11px] font-semibold text-amber-700" data-testid={testId}>
        {fallback}
      </span>
    );
  }
  return (
    <span className="bd-chip-order" data-testid={testId}>
      {value}
    </span>
  );
};

export default OrderChip;
